module.exports = __webpack_public_path__ + "static/media/02-banner-06-santa-fe@2x.64fb0246.jpg";